(() => {
  'use strict';

  const ENDPOINT = 'https://wall-theory-sophia-relay.wall-theory-8596.chatgpt.site/api/storefront';
  const SAMPLE_SELECTORS = '.klaviyo-form-TYtEsp,.klaviyo-form-TATyEC';
  const CATALOGUE_ACTION = 'manage.kmail-lists.com/subscriptions/subscribe';

  const country = () => location.hostname.endsWith('.ca') ? 'CA' : 'US';
  const id = () => crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const value = (form, name) => String(new FormData(form).get(name) || '').trim();
  const values = (form, name) => new FormData(form).getAll(name).map(String).map(v => v.trim()).filter(Boolean);

  const styles = `
    .sophia-intake{max-width:760px;margin:0 auto;padding:24px 0;text-align:left}
    .sophia-intake__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}
    .sophia-intake__field{display:flex;flex-direction:column;gap:6px}
    .sophia-intake__field--full{grid-column:1/-1}
    .sophia-intake label,.sophia-intake legend{font:600 14px/1.4 inherit;color:inherit}
    .sophia-intake input,.sophia-intake select{width:100%;min-height:48px;padding:11px 13px;border:1px solid #b9b2b5;border-radius:3px;background:#fff;color:#262226;font:inherit}
    .sophia-intake fieldset{margin:0;padding:0;border:0}
    .sophia-intake__checks{display:flex;flex-wrap:wrap;gap:10px 18px;margin-top:8px}
    .sophia-intake__checks label{display:flex;align-items:center;gap:7px;font-weight:400}
    .sophia-intake__checks input{width:auto;min-height:0}
    .sophia-intake__submit{margin-top:20px;min-height:48px;padding:12px 24px;border:0;border-radius:3px;background:#b26480;color:#fff;font:600 16px/1.2 inherit;cursor:pointer}
    .sophia-intake__submit[disabled]{opacity:.65;cursor:wait}
    .sophia-intake__status{min-height:24px;margin:12px 0 0;font-size:14px}
    .sophia-intake__trap{position:absolute!important;left:-10000px!important;width:1px!important;height:1px!important;overflow:hidden!important}
    @media(max-width:640px){.sophia-intake__grid{grid-template-columns:1fr}.sophia-intake__field--full{grid-column:auto}}
  `;

  function addStyles() {
    if (document.getElementById('sophia-direct-intake-styles')) return;
    const tag = document.createElement('style');
    tag.id = 'sophia-direct-intake-styles';
    tag.textContent = styles;
    document.head.appendChild(tag);
  }

  function sampleMarkup() {
    return `
      <form class="sophia-intake" data-sophia-flow="commercial_sample">
        <div class="sophia-intake__grid">
          <div class="sophia-intake__field"><label for="sophia-first">First name</label><input id="sophia-first" name="firstName" autocomplete="given-name" required></div>
          <div class="sophia-intake__field"><label for="sophia-last">Last name</label><input id="sophia-last" name="lastName" autocomplete="family-name" required></div>
          <div class="sophia-intake__field"><label for="sophia-email">Email</label><input id="sophia-email" name="email" type="email" autocomplete="email" required></div>
          <div class="sophia-intake__field"><label for="sophia-phone">Phone</label><input id="sophia-phone" name="phone" type="tel" autocomplete="tel"></div>
          <div class="sophia-intake__field"><label for="sophia-company">Company</label><input id="sophia-company" name="company" autocomplete="organization"></div>
          <div class="sophia-intake__field"><label for="sophia-city">City</label><input id="sophia-city" name="city" autocomplete="address-level2"></div>
          <div class="sophia-intake__field"><label for="sophia-role">Your role</label><select id="sophia-role" name="role" required><option value="">Select one</option><option>Contractor</option><option>Builder</option><option>Architect/Designer</option><option>Developer</option><option>Property Manager</option><option>Commercial Business Owner</option><option>Other</option></select></div>
          <div class="sophia-intake__field"><label for="sophia-help">How can we help?</label><select id="sophia-help" name="requestedHelp" required><option value="">Select one</option><option>Samples</option><option>Commercial Pricing</option><option>Project Quote</option><option>Product Recommendations</option><option>Multiple Items Above</option></select></div>
          <fieldset class="sophia-intake__field sophia-intake__field--full"><legend>Products of interest</legend><div class="sophia-intake__checks"><label><input type="checkbox" name="productInterest" value="Concrete"> Concrete</label><label><input type="checkbox" name="productInterest" value="Brick"> Brick</label><label><input type="checkbox" name="productInterest" value="Stone"> Stone</label><label><input type="checkbox" name="productInterest" value="Wood"> Wood</label></div></fieldset>
          <div class="sophia-intake__field sophia-intake__field--full"><label for="sophia-multi">Are you interested in products for multiple projects?</label><select id="sophia-multi" name="multiProjectInterest"><option value="">Select one</option><option value="Yes">Yes</option><option value="No">No</option></select></div>
          <div class="sophia-intake__trap" aria-hidden="true"><label>Website<input name="website" tabindex="-1" autocomplete="off"></label></div>
        </div>
        <button class="sophia-intake__submit" type="submit">Submit request</button>
        <p class="sophia-intake__status" role="status" aria-live="polite"></p>
      </form>`;
  }

  const inFlight = new WeakSet();
  const attempts = new WeakMap();

  async function submit(form, flow) {
    if (inFlight.has(form)) return;
    inFlight.add(form);
    const button = form.querySelector('[type="submit"],[type="button"]');
    const status = form.querySelector('.sophia-intake__status') || (() => {
      const p = document.createElement('p');
      p.className = 'sophia-intake__status';
      p.setAttribute('role', 'status');
      p.setAttribute('aria-live', 'polite');
      form.appendChild(p);
      return p;
    })();
    const fingerprint = JSON.stringify([flow, [...new FormData(form).entries()]]);
    const previous = attempts.get(form);
    const submissionId = previous?.fingerprint === fingerprint ? previous.id : id();
    attempts.set(form, { fingerprint, id: submissionId });
    const payload = {
      flow,
      country: country(),
      submissionId,
      timestamp: new Date().toISOString(),
      firstName: value(form, 'firstName') || value(form, '$first_name') || value(form, 'first_name'),
      lastName: value(form, 'lastName') || value(form, '$last_name') || value(form, 'last_name'),
      email: value(form, 'email') || value(form, '$email'),
      company: value(form, 'company') || value(form, '$organization'),
      phone: value(form, 'phone') || value(form, '$phone_number') || value(form, 'phone_number'),
      city: value(form, 'city') || value(form, '$city'),
      role: value(form, 'role'),
      requestedHelp: value(form, 'requestedHelp'),
      productInterest: values(form, 'productInterest'),
      multiProjectInterest: value(form, 'multiProjectInterest'),
      website: value(form, 'website'),
      campaign: `shopify-direct-${flow}`
    };
    button.disabled = true;
    status.textContent = 'Sending your request…';
    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Idempotency-Key': submissionId},
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      if (flow === 'commercial_sample') {
        location.assign('/pages/thank-you-1');
      } else {
        status.textContent = 'Opening the catalogue email confirmation…';
        HTMLFormElement.prototype.submit.call(form);
      }
    } catch (_) {
      status.textContent = 'We couldn’t submit this right now. Please try again or contact us.';
      status.setAttribute('role', 'alert');
      button.disabled = false;
      inFlight.delete(form);
    }
  }

  function replaceSampleEmbeds() {
    document.querySelectorAll(SAMPLE_SELECTORS).forEach(container => {
      if (container.dataset.sophiaDirect === 'true') return;
      container.dataset.sophiaDirect = 'true';
      container.classList.remove('klaviyo-form-TYtEsp', 'klaviyo-form-TATyEC');
      container.innerHTML = sampleMarkup();
      container.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        submit(event.currentTarget, 'commercial_sample');
      }, true);
    });
  }

  function wireCatalogueForms() {
    document.querySelectorAll(`form[action*="${CATALOGUE_ACTION}"]`).forEach(original => {
      if (original.dataset.sophiaDirect === 'true') return;
      const form = original.cloneNode(true);
      original.replaceWith(form);
      form.dataset.sophiaDirect = 'true';
      if (!form.id) form.id = 'sophia-catalogue-form';
      form.method = 'post';
      const status = document.createElement('p');
      status.className = 'sophia-intake__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
      const button = form.querySelector('[type="submit"]');
      if (button) {
        button.type = 'button';
        button.removeAttribute('onclick');
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (form.reportValidity()) submit(form, 'catalogue_download');
        }, true);
      }
      form.addEventListener('submit', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.reportValidity()) submit(form, 'catalogue_download');
      }, true);
    });
  }

  function replaceLegacyCatalogueLinks() {
    document.querySelectorAll(`a[href*="${CATALOGUE_ACTION}"]`).forEach(link => {
      link.href = '/pages/collection-catalogue#sophia-catalogue-form';
      link.removeAttribute('target');
      link.removeAttribute('rel');
    });
  }

  function initialize() {
    addStyles();
    replaceSampleEmbeds();
    wireCatalogueForms();
    replaceLegacyCatalogueLinks();
  }

  initialize();
  new MutationObserver(initialize).observe(document.documentElement, {childList: true, subtree: true});
})();
